var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item',{on:{"click":function($event){return _vm.redirectTo(_vm.redirectUrl)}}},[_c('v-list-item-icon',[_c('v-icon',{staticStyle:{"color":"#0259F3 !important"}},[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-item-title',{staticStyle:{"margin-left":"10px"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }